import React from "react";
import { Link } from "react-router-dom";
import capeLogo from "../images/cape.png";
import brandLogo from "./images/cape1.png";
import heroVideo from "./images/uber.mp4";

function UberCareKinKeepersPage() {
  return (
    <div className="ubercare-standalone-page">
      <header className="ubercare-topbar">
        <Link to="/" className="ubercare-topbar-brand" aria-label="Go to the UberCARE landing page">
          <img src={capeLogo} alt="UberCARE for Kin-keepers" className="topbar-logo" />
          <span className="topbar-title">UberCARE for Kin-keepers</span>
        </Link>
      </header>

      <main className="page-shell">
        <section className="page-panel">
          <div className="page-content">
            <div className="kinkeeper-hub-layout">
              <div>
                <div className="hub-badge">UberCARE</div>
                <h1 className="hub-title">Welcome to UberCARE for Kin-keepers</h1>
                <p className="hub-subtitle">
                  A calm, trusted place to organize elder support with confidence. UberCARE helps
                  Kin-keepers bring important family care details together so every next step feels
                  clearer, easier, and more reassuring.
                </p>
                <p className="section-copy">
                  From setting up elder profiles to keeping records current, this experience is designed
                  for the people who guide care with love, attention, and responsibility. It turns a
                  complicated process into one welcoming home for thoughtful action.
                </p>

                <div className="hub-feature-grid">
                  <div className="hub-feature-card">
                    <h3>Create elder profiles with ease</h3>
                    <p>Start each care journey smoothly with a guided place to organize personal and family details.</p>
                  </div>
                  <div className="hub-feature-card">
                    <h3>Keep care details organized</h3>
                    <p>Bring records, updates, and essential information together in one simple, reliable home.</p>
                  </div>
                  <div className="hub-feature-card">
                    <h3>Support loved ones with confidence</h3>
                    <p>Stay informed, prepared, and connected as you help the people who matter most.</p>
                  </div>
                </div>
              </div>

              <div className="hub-media-stack">
                <div className="hub-brand-card">
                  <img src={brandLogo} alt="UberCARE for Kin-keepers" className="selector-brand-logo" />
                  <div>
                    <div className="mini-label">UberCARE</div>
                    <h3>Your welcoming starting point for family care support</h3>
                    <p>Built to make elder care coordination feel clear, professional, and genuinely supportive from the very first visit.</p>
                  </div>
                </div>

                <div className="hero-card hero-visual media-card">
                  <div className="media-label">UberCARE guide</div>
                  <video className="hero-video" autoPlay muted loop controls>
                    <source src={heroVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default UberCareKinKeepersPage;
